/* Registrations.js */

"use strict";
let Registrations = {};
Registrations.APP = "App.Wizards";
Registrations.WIZARD_INSTANCE_EDITOR = "Editors.WizardInstanceEditor";
//VIEWS
Registrations.WIZARD_INSTANCE_EDITOR_VIEWS = Registrations.WIZARD_INSTANCE_EDITOR + ".Views";
Registrations.WIZARD_INSTANCE_EDITOR_EXECUTION_VIEW =
    Registrations.WIZARD_INSTANCE_EDITOR_VIEWS + ".Execution";
//ACTIONS
Registrations.WIZARD_INSTANCE_EDITOR_ACTIONS = Registrations.WIZARD_INSTANCE_EDITOR + ".Actions";
Registrations.WIZARD_INSTANCE_EDITOR_NAVIGATE_TO_EXECUTION_VIEW_ACTION =
    Registrations.WIZARD_INSTANCE_EDITOR_ACTIONS + ".Navigate.Execution";

module.exports = Registrations;
